module.exports = __webpack_public_path__ + "8430731e9ebb9758244e822674f502f0.png";